import React from 'react';
const RelatedLinks = () => {
  const relatedLinks = [
    {
      title: 'Calculer votre âge',
      url: '/calculator/fr/agegregorian/',
    },
    {
      title: 'Calculatrice IMC',
      url: '/calculator/fr/bmiadults/',
    },
    {
      title: 'Calculatrice de cycle menstruel',
      url: '/calculator/fr/period/',
    },
    {
      title: 'Calculatrice de grossesse',
      url: '/calculator/fr/pregnancy/',
    },
    {
      title: 'Convertisseur de devises',
      url: '/calculator/fr/currency/',
    },
    {
      title: 'Calculatrice de notes GPA',
      url: '/calculator/fr/gpagrade/',
    },
  ];
  return (
    <div style={{ margin: '20px 0' }}>
      <b style={{
        display: 'block',
        marginBottom: '15px',
        fontSize: '16px',
        color: '#1a5f3f',
      }}>
        Calculatrices qui pourraient vous intéresser :
      </b>
      <div className="related-links-container" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px'
      }}>
        {relatedLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary btn-sm"
            style={{
              marginBottom: '8px'
            }}
          >
            {link.title}
          </a>
        ))}
      </div>
    </div>
  );
};
export default RelatedLinks;
